import { createClient } from '@supabase/supabase-js'

const publicSupabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.VITE_PAULIE_PUBLIC_SUPABASE_URL
const publicSupabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_PAULIE_PUBLIC_SUPABASE_ANON_KEY

export const hasPublicSupabaseEnv = Boolean(publicSupabaseUrl && publicSupabaseAnonKey)

if (!hasPublicSupabaseEnv) {
  console.warn(
    'Missing public Supabase env vars. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'
  )
}

export const publicSupabase = hasPublicSupabaseEnv
  ? createClient(publicSupabaseUrl, publicSupabaseAnonKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false,
        detectSessionInUrl: false
      }
    })
  : null

export function getPublicSupabaseStatus() {
  if (hasPublicSupabaseEnv) {
    return { available: true, message: '' }
  }

  return {
    available: false,
    message:
      'Public data is unavailable because Supabase public environment variables are not configured for this deployment.'
  }
}
